import { Component, computed, input } from '@angular/core';
import { KENDO_PROGRESSBARS, LabelPosition } from '@progress/kendo-angular-progressbar';

@Component({
  selector: 'unity-progress-bar-shared',
  imports: [KENDO_PROGRESSBARS],
  templateUrl: './progress-bar-shared.component.html',
  styleUrl: './progress-bar-shared.component.scss',
})
export class ProgressBarSharedComponent {
  public readonly $value = input.required<number>({ alias: 'value' });
  public readonly $label = input.required<string>({ alias: 'label' });

  protected readonly $labelSettings = computed(() => ({
    visible: true,
    format: (value: number) => `${value}% ${this.$label()}`,
    position: 'start' as LabelPosition,
  }));
}
